module.exports = __webpack_public_path__ + "img/pupil-track.4d4535c4.png";